// src/pages/Founder.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import '../App.css';

const Founder = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  // Utility to render multiline bullet lists from translation
  const renderList = (key) =>
    t(key)
      .split('\n')
      .map((line, i) => {
        const trimmed = line.trim();
        if (!trimmed) return null;
        return <li key={i}>{trimmed.replace(/^•\s?/, '')}</li>;
      });

  // Utility to render paragraphs
  const renderParagraphs = (key) =>
    t(key)
      .split('\n')
      .map((line, i) => line.trim() && <p key={i}>{line.trim()}</p>);

  return (
    <div
      className={`container ${isRTL ? 'arabic-font' : ''}`}
      style={{ direction: isRTL ? 'rtl' : 'ltr', padding: '2rem 1rem', background: 'var(--cream)' }}
    >
      {/* Portrait */}
      <img
        src="/images/founder.jpg"
        alt={t('founderName')}
        className="founder"
      />

      {/* Page Title */}
      <h1 className="founder-section-title">{t('founderTitle')}</h1>
      <p style={{ textAlign: 'center', marginBottom: '2rem' }}>{t('founderTagline')}</p>

      {/* About the Founder */}
      <div className="founder-card">
        <h3>{t('founderTitle')}</h3>
        {renderParagraphs('founderBioIntro')}
      </div>

      {/* Credentials & Certifications */}
      <div className="founder-card">
        <h3>{t('founderCredHeading')}</h3>
        <ul style={{ marginLeft: '1rem' }}>
          {renderList('founderCredList')}
        </ul>
        <div style={{ marginTop: '1rem' }}>
          {renderParagraphs('founderJourney')}
        </div>
      </div>

      {/* Author & Educational Reformer */}
      <div className="founder-card">
        <h3>{t('founderAuthorHeading')}</h3>
        {renderParagraphs('founderAuthorList')}
      </div>

      {/* Global Impact & Advocacy */}
      <div className="founder-card">
        <h3>{t('founderImpactHeading')}</h3>
        <ul style={{ marginLeft: '1rem' }}>
          {renderList('founderImpactList')}
        </ul>
        <div style={{ marginTop: '1rem' }}>
          {renderParagraphs('founderImpactText')}
        </div>
      </div>

      {/* A Personal Calling */}
      <div className="founder-card">
        <h3>{t('founderCallingHeading')}</h3>
        {renderParagraphs('founderCallingText')}
      </div>
    </div>
  );
};

export default Founder;
